import { useTranslate } from '@dreryk/react-common';
import { Link, StrongText, StyledFlex, TooltipLabel } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../translations';

import { formatLastUpdateLine } from './SectionChipTooltip.utils';
import { DeepLinkTarget, SectionSummary } from './SectionSummary.types';

type SectionChipTooltipProps = {
   readonly summary: SectionSummary;
   readonly onDetails: (target: DeepLinkTarget) => void;
   readonly hideTooltip: VoidFunction;
};

export const SectionChipTooltip = (props: SectionChipTooltipProps): JSX.Element => {
   const translate = useTranslate();

   const handleDetailsClick = (): void => {
      props.hideTooltip();
      props.onDetails({ templateCode: props.summary.templateCode, sectionId: props.summary.sectionId });
   };

   return (
      <StyledFlex direction={'column'} gap={4}>
         <TooltipLabel label={appointmentsTranslationKeys.medicalProfile.title} />
         <StrongText testId={'sectionChipTitle'}>{props.summary.fullTitle}</StrongText>
         <span>{props.summary.valuesSummary}</span>
         <span>
            {formatLastUpdateLine(
               translate(appointmentsTranslationKeys.medicalProfile.showOnVisit.lastUpdate),
               props.summary.lastUpdate
            )}
         </span>
         <Link
            testId={'sectionChipDetails'}
            label={appointmentsTranslationKeys.medicalProfile.showOnVisit.details}
            onClick={handleDetailsClick}
         />
      </StyledFlex>
   );
};
